import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { IStoryblokEditor, IStoryblokEditorMessage } from '../../models/storyblok-editor.model';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    selector: 'butterfly-editor-mode',
    templateUrl: './editor-mode.component.html',
    styleUrls: ['./editor-mode.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditorModeComponent {
    @Input() content?: IStoryblokEditor;

    private _clipboard = inject(Clipboard);

    get pageUrl(): string {
        return this.content?.pageUrl ?? '';
    }

    get messages(): IStoryblokEditorMessage[] {
        return this.content?.messages ?? [];
    }

    onClick() {
        this._clipboard.copy(this.pageUrl);
    }
}
